import P from 'components/Font/P'
import React from 'react'

function Services() {
  return (
    <div> <P style={{ pl: 2 }} fontWeight={600} fontSize={35} fontFamily="Redressed">Services</P></div>
  )
}

export default Services